import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useNavigate, useParams } from 'react-router-dom'
import { trocaHorario } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirTrocaDiaTrabalho() {
    const navigate = useNavigate()
    const { id } = useParams<{ id: string }>()

    const { mutate, isLoading } = trocaHorario.diaTrabalho.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!id) return null

    const handleSubmit = () => {
        mutate(Number(id), {
            onSuccess: () => {
                toast.success('Troca de dia de trabalho removida com sucesso!')
                navigate(-1)
            },
            onError: err => {
                if (err.statusCode === 400) {
                    toast.error(err.message)
                } else {
                    toast.error('Erro ao remover troca de dia de trabalho')
                }
            },
        })
    }

    return (
        <Dialog.Root
            height="auto"
            width="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'TrocaDeDiaDeTrabalho'])}
        >
            <Dialog.Content>
                Deseja excluir a troca de dia de trabalho?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
